<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('settings/settings:option.options') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:option.option') })"
            icon="edit"
            @updateTableData="updateTable"
            @clickedButton1="editOption"
            @clickedAddButton="editOption"
            :addBtn="true"
            sortBy="name"
        />

      </v-col>
    </v-row>

    <OptionForm
        @updateTable="updateTableAfterManipulation"
        ref="optionForm" />

  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import OptionForm from '@/modules/settings/views/settings/option/OptionForm.vue';
import OptionService from '@/modules/settings/services/option-service';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import Option from '@/modules/settings/data/option';

export default {
  name: "OptionTable",
  components: {
    OptionForm,
    DataTablePaginated
  },
  data() {
    return {
      option: new Option(),
      options: [],
      optionTypes: []
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:type'), value: 'type'},
        {text: this.$t('settings/settings:option.default'), value: 'defaultValue'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      OptionService.readAllOptionsPaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Option);
            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:option.option')}));
          }
      )
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editOption(meta) {
      this.$refs.optionForm.initialization(meta);
    }
  }
}
</script>